// extracted by mini-css-extract-plugin
export default {"scrollable":"SendGift_scrollable__J9lKG","modalWrapper":"SendGift_modalWrapper__LHHkW"};